import React from 'react'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { notifyOpener } from 'Helpers/notifyParent'
import { useParams } from 'react-router-dom'
import { MESSAGE_TYPE_CONTENTSCAMPAIGN } from 'Constants'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { useIntl } from 'react-intl'

import {
  isValidFormState,
  pageState,
  recipientsState,
  ACTUAL_VIEW_RECIPIENTS
} from 'Pages/QuickSend/recoil/state/state'
import {
  sendCallback,
  verifyRecipientEmailsCallback
} from 'Pages/QuickSend/recoil/callbacks/callbacks'

const Footer = () => {
  const intl = useIntl()
  const { id: idMessage } = useParams()

  const { messageType, isBee, messageErrors, gracePeriod } = useRecoilValue(
    pageState
  )
  const enableSend = useRecoilValue(isValidFormState)
  const [{ emailAddress, actualView }, setRecipientsState] = useRecoilState(
    recipientsState
  )

  const verifyRecipientEmails = useRecoilCallback(
    verifyRecipientEmailsCallback,
    []
  )

  const send = useRecoilCallback(sendCallback, [])

  const handleEdit = () => {
    if (isBee) {
      notifyOpener('redirectMainFrame', [
        `/console/messages_app_redirector.aspx?r=/messages/email/bee/edit/${idMessage}`
      ])
    } else {
      notifyOpener('redirectMainFrame', [
        `/console/form_upd_newsletter.aspx?source=listemail&idNL=${idMessage}`
      ])
    }
  }

  const handleSend = () => {
    if (emailAddress !== '' && actualView === ACTUAL_VIEW_RECIPIENTS) {
      verifyRecipientEmails().then(e => {
        e && send(idMessage)
      })
    } else {
      setRecipientsState(prev => ({
        ...prev,
        error: false
      }))
      send(idMessage)
    }
  }

  return (
    <Flex justifyContent='flex-end' columnGap='8px' padding='0 0 4px 0'>
      {messageType !== MESSAGE_TYPE_CONTENTSCAMPAIGN && (
        <FlexItem>
          <Button kind={BUTTON_VARIANT_SECONDARY} onClick={handleEdit}>
            {intl.formatMessage({ id: 'Load.MailupCommon.EditMessage' })}
          </Button>
        </FlexItem>
      )}
      <FlexItem>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleSend}
          disabled={!enableSend || messageErrors || gracePeriod === 2}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
        </Button>
      </FlexItem>
    </Flex>
  )
}

export default Footer
